import { Component, input } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';

import { Service } from '../../../../core/models/service.type';

@Component({
  selector: 'app-service-card',
  imports: [MatIconModule, TranslateModule],
  host: {
    class: 'block',
  },
  templateUrl: './service-card.component.html',
  styleUrl: './service-card.component.scss',
})
export class ServiceCard {
  service = input.required<Service>();
}
